import { createCalendar } from "../app_js/framework/components/fullcalendar";

export function initProgramSessionsCalendar() {
  const containerEl = document.querySelector(".js-program-sessions-calendar");
  const triggerEl = document.querySelector('[data-action="popup:open"][data-target="#program-sessions-calendar-popup"]');
  if (!containerEl || !triggerEl) return;

  let calendarPromise = null;

  triggerEl.addEventListener("click", async () => {
    if (!calendarPromise) {
      calendarPromise = mountCalendar(containerEl);
    }

    const calendar = await calendarPromise;
    requestAnimationFrame(() => calendar.updateSize());
  });
}

async function mountCalendar(containerEl) {
  const titleEl = document.querySelector(".js-program-sessions-calendar-title");
  const prevBtn = document.querySelector(".js-program-sessions-calendar-prev");
  const nextBtn = document.querySelector(".js-program-sessions-calendar-next");
  const todayBtn = document.querySelector(".js-program-sessions-calendar-today");
  const sessionFilterEl = document.querySelector(".js-program-sessions-calendar-session-filter");
  const baseEventsUrl = containerEl.dataset.eventsUrl;

  const calendar = await createCalendar(containerEl, {
    initialView: "dayGridMonth",
    headerToolbar: false,
    height: "auto",
    events: buildEventsUrl(baseEventsUrl, sessionFilterEl?.value),
    displayEventEnd: true,
    eventTimeFormat: {
      hour: "numeric",
      minute: "2-digit",
      omitZeroMinute: true,
    },
    eventClick({ event, jsEvent }) {
      jsEvent.preventDefault();
      const url = event.extendedProps.registrationPath;
      if (url) window.location.href = url;
    },
    eventDidMount({ event, el }) {
      const modality = event.extendedProps.modality;
      if (modality) el.title = `${event.title} · ${modality}`;
    },
    datesSet({ view }) {
      if (titleEl) titleEl.textContent = view.title;
    },
  });

  prevBtn?.addEventListener("click", () => calendar.prev());
  nextBtn?.addEventListener("click", () => calendar.next());
  todayBtn?.addEventListener("click", () => calendar.today());

  sessionFilterEl?.addEventListener("change", () => {
    calendar.removeAllEventSources();
    calendar.addEventSource(buildEventsUrl(baseEventsUrl, sessionFilterEl.value));
  });

  return calendar;
}

function buildEventsUrl(baseUrl, sessionId) {
  if (!sessionId) return baseUrl;
  return `${baseUrl}?training_session_id=${sessionId}`;
}
